import * as React from 'react';

import Circle from '../loading/Circle';

const Dialog = require('rc-dialog');

interface IProps {
    widgetName: string
}

export default class LoadingModal extends React.Component<IProps, {}> {
    render() {
        return (
            <Dialog visible closable={false} maskClosable={false} keyboard={false}>
                <Circle size="xxl" name={this.props.widgetName} infinite />
            </Dialog>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/modal/LoadingModal.tsx